import { IGerarRemessaSicredi } from "@/banks/sicredi/types";
import { Arquivo } from "@/lib/Arquivo";
import { removerCaracterEspecial } from "@/utils/removerCaracterEspecial";
import { format } from "date-fns";

export function gerarRemessa({ dados }: IGerarRemessaSicredi) {
  try {
    const { dadosBancario, beneficiario, boletos } = dados.remessa;

    const arquivo = new Arquivo();
    const data = new Date();

    let protestar = '00';
    let negativar = '0000';

    switch (dadosBancario.tipo_protesto) {
      case 'Nenhum':
        protestar = '00';
        negativar = '0000';
        break;
      case 'Protestar':
        protestar = '06';
        negativar = '0000';
        break;
      case 'Negativar':
        protestar = '00';
        negativar = '06' + String(dadosBancario.diasProtesto).padStart(2, '0');
        break;
      default:
        protestar = '00';
        negativar = '0000';
        break;
    }

    // Header do arquivo
    arquivo.add('01REMESSA');
    arquivo.add('01');
    arquivo.add('COBRANCA'.padEnd(15, ' '));
    arquivo.add(dadosBancario.codigo_cedente);
    arquivo.add(beneficiario.cnpj);
    arquivo.add(' '.padEnd(31, ' '));
    arquivo.add('748');
    arquivo.add('SICREDI'.padEnd(15, ' '));
    arquivo.add(format(data, 'yyyyMMdd'));
    arquivo.add(' '.padEnd(8, ' '));
    arquivo.add(dadosBancario.numeroRemessa.padStart(7, '0'));
    arquivo.add(' '.padEnd(273, ' '));
    arquivo.add('2.00');
    arquivo.add('000001');

    arquivo.addLine();
    let sequencia = 2;
    let total = 0;

    // Registros arquivo
    for (const boleto of boletos) {
      const { pagador } = boleto;
      total += Number(boleto.valor);

      let tipoInscricao = pagador.pessoa === 'F' ? '1' : '2';

      // cálculos desconto
      let desconto = '0000000000000';
      let dataDesconto = '000000';

      if (boleto.desconto) {
        desconto = boleto.desconto.toFixed(2).replace('.', '').padStart(13, '0');
        dataDesconto = format(new Date(boleto.vencimento), 'ddMMyy');
      }

      if (!boleto.desconto && dadosBancario.descontoPagamento) {
        desconto = dadosBancario.descontoPagamento.toFixed(2).replace('.', '').padStart(13, '0');
        dataDesconto = format(new Date(boleto.vencimento), 'ddMMyy');
      }

      // cálculos juros
      let valorJurosDias = Number(boleto.valor) * Number(dadosBancario.jurosMes) / 100 / 30;
      let multaAtraso = String(dadosBancario.multaAtraso * 100);

      arquivo.add('1');
      arquivo.add('AAA');
      arquivo.add(' '.padEnd(12, ' '));
      arquivo.add('AAA');
      arquivo.add(' '.padEnd(28, ' '));
      arquivo.add(boleto.nossoNumero.padEnd(9, ' '));
      arquivo.add(' '.padEnd(6, ' '));
      arquivo.add(format(new Date(boleto.emissao), 'yyyyMMdd'));
      arquivo.add(' ');
      arquivo.add('N');
      arquivo.add(' ');
      arquivo.add('B');
      arquivo.add('0000');
      arquivo.add(' '.padEnd(4, ' '));
      arquivo.add('0'.padEnd(10, '0'));
      arquivo.add(multaAtraso.padStart(4, '0'));
      arquivo.add(' '.padEnd(12, ' '));
      arquivo.add('01');
      arquivo.add(boleto.identificacaoTitulo.padEnd(10, ' ')); // identificacao titulo, usar depois (retorno)
      arquivo.add(format(new Date(boleto.vencimento), 'ddMMyy'));
      arquivo.add(Number(boleto.valor).toFixed(2).replace('.', '').padStart(13, '0'));
      arquivo.add(' '.padEnd(9, ' '));
      arquivo.add('A'); // especie
      arquivo.add(boleto.aceite); // aceite
      arquivo.add(format(new Date(boleto.emissao), 'ddMMyy'));
      arquivo.add(protestar);
      arquivo.add(String(dadosBancario.diasProtesto).padStart(2, '0'));
      arquivo.add(Number(valorJurosDias).toFixed(2).replace('.', '').padStart(13, '0'));
      arquivo.add(dataDesconto);
      arquivo.add(desconto);
      arquivo.add(negativar);
      arquivo.add('0'.padEnd(22, '0'));
      arquivo.add(tipoInscricao);
      arquivo.add('0');
      arquivo.add(pagador.cpfCnpj.padStart(14, '0'));
      arquivo.add(removerCaracterEspecial(pagador.nome).substring(0, 40).padEnd(40, ' '));
      arquivo.add(removerCaracterEspecial(pagador.endereco.logradouro).substring(0, 40).padEnd(40, ' '));
      arquivo.add('0'.padEnd(11, '0'));
      arquivo.add(' ');
      arquivo.add(pagador.endereco.cep.padEnd(8, ' '));
      arquivo.add('00000');
      arquivo.add(' '.padEnd(55, ' '));
      arquivo.add(String(sequencia).padStart(6, '0'));

      arquivo.addLine();
      sequencia++;
    }

    arquivo.add('91748');
    arquivo.add(dadosBancario.codigo_cedente);
    arquivo.add(' '.padEnd(384, ' '));
    arquivo.add(String(sequencia).padStart(6, '0'));
    arquivo.addLine();

    return {
      download: `${dadosBancario.codigo_cedente}${retornaMes(data)}${format(data, 'dd')}.crm`,
      arquivo: arquivo.getArquivo(),
    };
  } catch (error) {
    console.log(error);
    return null;
  }
}

function retornaMes(data: Date) {
  const mes = data.getMonth() + 1;

  switch (mes) {
    case 10:
      return 'O';
    case 11:
      return 'N';
    case 12:
      return 'D';
    default:
      return mes.toString();
  }
}
